// extracted by mini-css-extract-plugin
export default {"footnoteContainer":"styles_footnoteContainer__Q40Pu","wrapper":"styles_wrapper__7mTiD","border":"styles_border__cvVWx","notes":"styles_notes__R0YFx"};